import { Component, inject, input } from '@angular/core';

import { BOProduct, Media } from '@boels/models';
import { MediaService } from '@boels/services';
import { normalizeImages } from '@boels/helpers';

@Component({
  selector: 'boels-product-thumbnail',
  imports: [],
  providers: [MediaService],
  templateUrl: './product-thumbnail.component.html',
  styleUrl: './product-thumbnail.component.scss',
})
export class ProductThumbnailComponent {
  product = input.required<BOProduct>();
  mediaService = inject(MediaService);

  getMedia(product: BOProduct): Media | undefined {
    return this.mediaService.getMedia(
      product.images?.PRIMARY || normalizeImages(product.images)?.['PRIMARY'],
    );
  }
}
